import * as Api from "@api";
import { State } from "../";
import { ActionType } from "../types";
import { ThunkAction } from "redux-thunk";
import { Environment, EnvironmentsAction } from "../types/environments";

function getEnvironmentsRequest(key: string): EnvironmentsAction {
  return {
    type: ActionType.GET_ENVIRONMENTS_REQUEST,
    key,
  };
}

function getEnvironmentsSuccess(
  key: string,
  environments: Environment[]
): EnvironmentsAction {
  return {
    type: ActionType.GET_ENVIRONMENTS_SUCCESS,
    key,
    environments,
  };
}

function getEnvironmentsFailure(key: string, error: any): EnvironmentsAction {
  return {
    type: ActionType.GET_ENVIRONMENTS_FAILURE,
    key,
    error,
  };
}

export function getEnvironments(
  application?: number
): ThunkAction<void, State, unknown, EnvironmentsAction> {
  return async (dispatch, getState) => {
    const { network } = getState();
    const key = `${application?.toString() || "*"}`;

    if (!network.fetching.environments[key]) {
      dispatch(getEnvironmentsRequest(key));
      try {
        const environments = await Api.getEnvironments(application);

        dispatch(getEnvironmentsSuccess(key, environments));
      } catch (error) {
        dispatch(getEnvironmentsFailure(key, error));
      }
    }
  };
}
